<mat-card appearance="outlined">
  <mat-card-header>
    <mat-card-title>{{ "CREDITS.HISTORY.TITLE" | translate }}</mat-card-title>
  </mat-card-header>

  <mat-card-content>
    <app-date-filter
      [dateFrom]="dateFrom"
      [dateTo]="dateTo"
      [loading]="tableLoading() || historyLoading()"
      (refresh)="refresh()"
    ></app-date-filter>
  </mat-card-content>

  <mat-card-content>
    <h2>
      {{ "CREDITS.TABLE.TITLE" | translate }}
    </h2>
  </mat-card-content>

  <app-credit-spending-table
    [data]="creditTable"
    [loading]="tableLoading()"
  ></app-credit-spending-table>

  @if (historyLoading()) {
    <mat-card-content class="history-loading">
      <mat-progress-spinner
        mode="indeterminate"
        diameter="40"
      ></mat-progress-spinner>
      <span>{{ "CREDITS.HISTORY.LOADING" | translate }}</span>
    </mat-card-content>
  }

  @if (!historyLoading() && creditHistory.length === 0) {
    <mat-card-content class="no-history">
      <payee-icon name="info-grey-outline"></payee-icon>
      <span>{{ "CREDITS.HISTORY.NO_HISTORY" | translate }}</span>
    </mat-card-content>
  }

  @if (!historyLoading() && creditHistory.length > 0) {
    <mat-card-content>
      <div class="flex column history-list">
        @for (item of pagedCreditHistory; track item.date + item.label + item.amount) {
          <mat-card appearance="outlined">
            <mat-card-content>
              <app-credit-history-item [item]="item"></app-credit-history-item>
            </mat-card-content>
          </mat-card>
        }
      </div>
    </mat-card-content>
  }

  <mat-card-footer>
    @if (creditHistory.length > 5) {
      <mat-paginator
        [length]="creditHistory.length"
        [pageSize]="pageSize"
        [pageIndex]="pageIndex"
        [pageSizeOptions]="[1, 5, 10, 25]"
        (page)="pageChange($event)"
      ></mat-paginator>
    }
  </mat-card-footer>
</mat-card>
